import NanoBananAi from './NanoBananAi'

export default NanoBananAi
